// extracted by mini-css-extract-plugin
export default {"board":"Board_board__IksR5","score":"Board_score__VyQH2","death":"Board_death__3Zxat","gamePause":"Board_gamePause__mNGl+"};